<template>
  <div>
    <c-card reference="Climb > Usuários" title="Usuários">
      <template slot="icons">
        <icon class="icon" @click="novoUsuario" icon="plus"></icon>
        <icon class="icon" @click="abrirFiltros" icon="filter">
          <span v-if="totalFilters" class="card-icons-alert"
            >@{{ totalFilters }}</span
          >
        </icon>
      </template>

      <c-list :items="usuarios" class="mb-3">
        <template v-slot:items="item">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <div>
                <span
                  style="font-size: .9em; color: #222; font-weight: bold;"
                  >{{ item.data.nome }}</span
                >
                <span style="font-size: .9em; color: #222;"
                  >({{ item.data.nivel }})</span
                >
              </div>
              <span style="font-size: .8em; color: #6f6f6f">{{
                item.data.email
              }}</span>
            </div>
            <div class="list-icons">
                <span @click="usuario = item.data; statusUsuarioModal = true" style="cursor: pointer;">
                    <span v-if="item.data.data_inativacao">
                        <icon
                            class="icon"
                            icon="toggle-on"
                        ></icon> Inativar campanha
                    </span>
                    <span v-else>
                        <icon
                            class="icon"
                            icon="toggle-off"
                            style="margin-left: 15px;"
                        ></icon> Inativar campanha
                    </span>
                </span>
                <icon
                    class="icon"
                    @click="editarUsuario(item.data)"
                    icon="pen"
                ></icon>
            </div>
          </div>
        </template>
      </c-list>
      <span class="card-divisor mb-3"></span>

      <div class="d-flex justify-content-between">
        <span style="font-size: .8em;font-weight: bold;">
          {{ (page - 1) * limit + 1 }} -
          {{ page * limit > totalRows ? totalRows : page * limit }} /
          {{ totalRows }}
        </span>
        <b-pagination
          v-model="page"
          :total-rows="totalRows"
          :per-page="limit"
          aria-controls="my-table"
          pills
          size="sm"
          class="mb-0"
          @change="loadUsuarios"
        ></b-pagination>
      </div>
    </c-card>
    <c-modal title="Usuario" v-model="modalUsuario" size="full">
      <template v-slot:buttons>
        <button v-if="!loading" @click="salvarUsuario">Salvar</button>
        <button v-else @click="salvarUsuario" :disabled="loading">
          <b-spinner class="mr-2" small></b-spinner> Cadastrando usuário
        </button>
      </template>

      <b-row>
        <b-col>
          <b-form-group
            label-size="sm"
            v-for="(field, i) in commonFields"
            :key="i"
            :label="field.name"
            :label-for="field.attribute"
          >
            <div v-if="field.attribute == 'senha'" style="display: flex;">
              <b-form-input
                id="field.attribute"
                v-if="field.attribute == 'senha'"
                v-model="usuario[field.attribute]"
                type="text"
                placeholder="*******"
                disabled="disabled"
              ></b-form-input>
              <span
                v-if="field.attribute == 'senha'"
                class="input-group-btn"
                title="Gerar nova senha"
              >
                <button type="button" class="btn gerar" @click="generate()">
                  <icon icon="sync"></icon>
                </button>
              </span>
            </div>
            <b-form-input
              id="field.attribute"
              v-if="field.attribute != 'senha'"
              v-model="usuario[field.attribute]"
              type="text"
              :disabled="loading"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label-size="sm"
            label="Nível Usuário"
            label-for="nivel_usuario_id"
          >
            <b-form-select
              id="nivel_usuario_id"
              v-model="usuario['nivel_usuario_id']"
              :options="optionsNiveis"
              class="mb-3"
              :disabled="loading"
            >
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>

    <c-modal title="Filtro" v-model="modalFiltro" size="md">
      <template v-slot:buttons>
        <button @click="limparFiltros">Limpar</button>
        <button @click="filtrarUsuarios">Filtrar</button>
      </template>
      <b-row>
        <b-col>
          <b-form-group label-size="sm" label="Nome" label-for="filtro-nome">
            <b-form-input
              id="filtro-nome"
              v-model="temporaryFilters.nome"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-size="sm" label="Email" label-for="filtro-email">
            <b-form-input
              id="filtro-email"
              v-model="temporaryFilters.email"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-size="sm"
            label="Nível Usuário"
            label-for="filtro-nivel"
          >
            <b-form-select
              id="filtro-nivel"
              v-model="temporaryFilters.nivel_usuario_id"
              :options="optionsNiveis"
              class="mb-3"
            >
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>
    <c-modal v-model="statusUsuarioModal" :title="(usuario.data_inativacao ? 'Ativar' : 'Inativar') + ' usuário'" size="md">

        <template v-slot:buttons>
            <button @click="statusUsuarioModal = false" size="sm">Não</button>
            <button @click="toggleCampanha" size="sm" variant="primary">Sim</button>
        </template>

        Deseja realmente {{usuario.data_inativacao ? 'ativar' : 'inativar'}} o usuário?

    </c-modal>
  </div>
</template>

<script>
import usuarioService from "@/services/usuarioService.js";
import niveisService from "@/services/niveisService.js";

import CList from "@/components/CList.vue";
import CModal from "@/components/CModal.vue";
import CCard from "@/components/CCard.vue";

import { mapActions } from "vuex";

export default {
  name: "Usuarios",
  data() {
    return {
      usuarios: [],
      niveis: [],
      modalUsuario: false,
      modalFiltro: false,
      loading: false,
      usuario: [],
      temporaryFilters: {},
      statusUsuarioModal: false,
      filters: {
        nome: null,
        email: null,
        nivel_usuario_id: null
      },
      commonFields: [
        { name: "Nome", attribute: "nome" },
        { name: "Email", attribute: "email" },
        { name: "Senha", attribute: "senha" }
      ],
      limit: 15,
      page: 1,
      totalRows: 0
    };
  },
  methods: {
    ...mapActions("notification", { notificate: "add" }),
    loadUsuarios(pageNumber) {
      usuarioService
        .getAll(this.limit, pageNumber, this.filters)
        .then(res => {
          this.usuarios = res.data.data;
          this.totalRows = res.data.totalRows;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    loadNiveis() {
      niveisService
        .getAll()
        .then(res => {
          this.niveis = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    generate() {
      let CharacterSet =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789![]{}()%&*$#^<>~@|.";

      let password = "";

      for (let i = 0; i < 9; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }

      this.usuario.senha = password;
    },
    editarUsuario(usuario) {
      this.usuario = {
        ...JSON.parse(JSON.stringify(usuario)),
        senha: null
      };

      this.modalUsuario = true;
    },
    novoUsuario() {
      this.usuario = {
        nome: null,
        email: null,
        senha: null,
        nivel_usuario_id: null,
        data_inativacao: null
      };

      this.generate();

      this.loading = false;
      this.modalUsuario = true;
    },
    salvarUsuario() {
      this.loading = true;

      let data = JSON.parse(JSON.stringify(this.usuario));

      if (this.usuario.id) {
        if (!data.senha) delete data.senha;
        usuarioService
          .update(this.usuario.id, data)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalUsuario = false;

            res = "Usuário alterado com sucesso";

            this.loadUsuarios();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      } else {
        usuarioService
          .create(data)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalUsuario = false;

            res = "Usuário cadastrado com sucesso";

            this.loadUsuarios();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      }
    },
    abrirFiltros() {
      this.temporaryFilters = JSON.parse(JSON.stringify(this.filters));
      this.modalFiltro = true;
    },
    filtrarUsuarios() {
      this.page = 1;
      this.modalFiltro = false;
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));
      this.loadUsuarios();
    },
    limparFiltros() {
      Object.keys(this.temporaryFilters).forEach(k => {
        this.temporaryFilters[k] = null;
      });
    },
    toggleCampanha() {
        let ativar = this.usuario.data_inativacao

        usuarioService
          .toggleUsuario(this.usuario.id, (ativar ? 'ativar' : 'inativar'))
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            res = 'Usuário ' + (ativar ? 'ativado' : 'inativado') + ' com sucesso';

            this.loadUsuarios();
            this.statusUsuarioModal = false

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
    }
  },
  components: {
    CList,
    CModal,
    CCard
  },
  computed: {
    optionsNiveis() {
      return this.niveis.map(o => ({
        value: o.id,
        text: o.nome
      }));
    },
    totalFilters() {
      return Object.keys(this.filters).filter(
        k => this.filters[k] && this.filters[k] != ""
      ).length;
    }
  },
  mounted() {
    this.loadUsuarios(1);
    this.loadNiveis();
  }
};
</script>

<style lang="css">
.icon:hover {
  cursor: pointer;
  color: #737373;
}

.gerar {
  color: #fff !important;
  background-color: #2c3e50 !important;
  border-color: #2c3e50 !important;
}

.gerar:hover {
  background-color: #34495e !important;
  border-color: #34495e !important;
}

.card-icons > svg {
  margin-left: 15px;
  cursor: pointer;
  position: relative;
}
</style>
